import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { EcitationUserService } from 'src/services/ecitation-user.service';
import { EcitationServiceService } from '../ecitation-service.service';
import { catchError, of } from 'rxjs';
import { AlertService } from '../alert-notify/alert-notify.service';

@Component({
    selector: 'app-ecitation-login',
    templateUrl: './ecitation-login.component.html',
    styleUrls: ['./ecitation-login.component.css'],
    standalone: false
})
export class EcitationLoginComponent {

  responseMessage: any
  successMsg: any;
  error: boolean = false
  listAllUserDetails: any = []
  constructor(private route: Router,
    private authService: AuthService,
    private ecitationServiceService: EcitationServiceService,
    private ecitationUserService: EcitationUserService,
    private formBuilder: FormBuilder,
    public alertService: AlertService
  ) { }

  loginForm: any = FormGroup;
  resetPasswordForm: any = FormGroup;
  isPasswordResetEnabled: boolean = false

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
    })
  }

  loginUser() {
    let formData = this.loginForm.value;
    let data = {
      username: formData.username.trim(),
      password: formData.password.trim()
    }

    this.authService.loginUser(data).subscribe({
      next: (response: any) => {
        try {
          
       
        if (response.passwordResetToken) {
          this.responseMessage = ['Password Expired (90 Days)', 'Please reset to continue']
          this.createResetForm(response.passwordResetToken);
          this.isPasswordResetEnabled = true;
        } else {
          this.authService.addAccessToken(response.accessToken);
          this.authService.addRefreshToken(response.refreshToken);
          const role = this.authService.getUserRole()
          if (role === 'ROLE_ADMIN') {
            this.authService.isNonAdminActive = false;
            sessionStorage.setItem('isNonAdminActive', 'false')
            sessionStorage.setItem('menuType', role)
            this.ecitationUserService.reloadComponent1()
            this.route.navigate(['secure/ecitationMuniStatus'])
          } else {
            sessionStorage.setItem('menuType', role)
            this.authService.isNonAdminActive = true;
            sessionStorage.setItem('isNonAdminActive', 'true')
            this.ecitationUserService.reloadComponent1()
            this.route.navigate(['secure/ecitationSearch'])

          }
          this.responseMessage = null;
          this.successMsg = null
          sessionStorage.setItem('loggedInUser', JSON.stringify({ username: formData.username }));
        }
      } catch (error) {
        
          this.responseMessage = response?.message == '401-OK Bad credentials' ? ['Login Failed', ' Your username/password is incorrect. Please try again.'] : [response?.message?.substring(response?.message), 'Please contact your administrator.']
          error = true
          this.successMsg = null;
          setTimeout(() => {
            this.responseMessage = null
          }, 7000);
        
      }
      }, error: (error: any) => {
        if (error?.message) {
          this.responseMessage = error?.message == '401-OK Bad credentials' ? ['Login Failed', ' Your username/password is incorrect. Please try again.'] : [error?.message?.substring(error?.message.indexOf(' ') + 1), 'Please contact your administrator.']
          error = true
          this.successMsg = null
          setTimeout(() => {
            this.responseMessage = null
          }, 7000);
        }
      }, complete: () => {

      }
    })

    this.ecitationServiceService.triggerRefresh()

  }
  createResetForm(resetToken: string) {
    this.resetPasswordForm = this.formBuilder.group({
      newPassword: [null, [Validators.required]],
      passwordResetToken: [resetToken, [Validators.required]],
    })
  }
  reset() {
    this.loginForm.reset()
  }
  resetPassword() {
    let formData = this.resetPasswordForm.value;
    this.authService.resetPassword(formData).subscribe({
      next: (response: any) => {
        this.isPasswordResetEnabled = false;
        this.resetPasswordForm.reset();
        this.loginForm.reset();
        this.responseMessage = null;
        this.successMsg = ['Password has been reset sucessfully', 'Please login with the new Password']
        setTimeout(() => {
          this.successMsg = null
        }, 7000);
      }, error: (error: any) => {
        if (error?.message) {
          this.responseMessage = error?.message == '401-OK Bad credentials' ? ['Login Failed', ' Your username/password is incorrect. Please try again.'] : [error?.message, 'Please contact your administrator.']
          error = true
          this.successMsg = null;
          setTimeout(() => {
            this.responseMessage = null
          }, 7000);
        }
      }, complete: () => {

      }
    })
  }
  generatePass(type: string) {

    let password = this.generateRandomPassword(16);

    this.resetPasswordForm.controls.newPassword.setValidators([Validators.required])
    this.resetPasswordForm.controls.newPassword.setValue(password)
    this.resetPasswordForm.markAsDirty()
    this.resetPasswordForm.controls.newPassword.updateValueAndValidity()

  }
  generateRandomPassword(length: number) {
    let charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const randomValue = new Uint32Array(Math.ceil(length / 2));
    const crypto = window.crypto;
    crypto.getRandomValues(randomValue)
    let randomString = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = randomValue[i % randomValue.length] % charset.length;
      randomString += charset[randomIndex]
    }
    return randomString
  }
}
